import React from 'react'
import { Desktop, Mobile } from '../../../../components/MediaQuery'
import { Modals } from '../../../Modals/ModalContainer'
import { CreateRoomModal } from '../../RoomModal'
import RoomForms from '../../../Form/CreateRoom'
import PrintModal from '../../PrintModal'
import ToolbarMobile from './ToolbarMobile'
import ToolbarDesktop from './ToolbarDesktop'

export default function Toolbar({
  modalOpen,
  modalClose,
  openAddReservationModal,
  toggleSummary,
  size = 1,
  isPremium,
  summary,
}: IToolbarDispatch & IToolbarProps) {
  function openAddRoomModal() {
    modalOpen(
      Modals.AddRoom,
      <CreateRoomModal close={modalClose}>
        <RoomForms.Create />
      </CreateRoomModal>,
    )
  }

  function openPrintModal() {
    modalOpen(Modals.PrintModal, <PrintModal onClose={modalClose} />)
  }

  return (
    <React.Fragment>
      <Desktop>
        <ToolbarDesktop
          size={size}
          summary={summary}
          openAddRoomModal={openAddRoomModal}
          openAddReservationModal={openAddReservationModal}
          toggleSummary={toggleSummary}
        />
      </Desktop>
      <Mobile>
        <ToolbarMobile
          summary={summary}
          openAddRoomModal={openAddRoomModal}
          openPrintModal={openPrintModal}
          openAddReservationModal={openAddReservationModal}
          toggleSummary={toggleSummary}
          isPremium={isPremium}
        />
      </Mobile>
    </React.Fragment>
  )
}

export interface IToolbarDispatch {
  modalOpen?: (id, element) => void
  modalClose?: (id) => void
  toggleSummary: () => void
  openAddReservationModal: () => void
  size?: number
}

export interface IToolbarProps {
  summary?: boolean
  isPremium?: boolean
  licence?: any
}
